import React from "react";
import { getAllLogs, getUsers } from "API/swesum";
import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";

import { useLoaderData } from "react-router-dom";
import SystemTable from "./components/SystemTable";
import MainLayout1 from "Components/UI/Layout/MainLayout1";

export async function loader() {
  const logs = await getAllLogs();
  const users = await getUsers();

  return { logs, users };
}

export function System() {
  const { logs, users } = useLoaderData();

  return (
    <>
      <MainLayout1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1.0rem",
          }}
        >
          <Typography variant="h5">Loggar</Typography>
        </Box>
        <SystemTable logs={logs} users={users} />
      </MainLayout1>
    </>
  );
}
